import React from 'react';

import { SelectedContentGridLayout } from '../selected-content-grid-layout';

import style from './container-query-layout.module.less';

/**
 * @param {object} props
 * @param {React.ReactNode} [props.column1Sections]
 * @param {React.ReactNode} [props.column2Sections]
 * @param {React.ReactNode} [props.column3Sections]
 * @param {React.ReactNode} props.fulfillmentPlannerSections
 * @param {React.ReactNode} props.primaryShipmentSections
 * @param {React.ReactNode} [props.rateCard]
 * @param {React.ReactNode} props.secondaryShipmentSections
 * @returns {JSX.Element}
 */
export const LayoutContainer = ({
  column1Sections,
  column2Sections,
  column3Sections,
  primaryShipmentSections,
  fulfillmentPlannerSections,
  secondaryShipmentSections,
  rateCard = null,
}) => {
  return (
    <div className={style['order-details-selected-content-grid-layout-container']}>
      <SelectedContentGridLayout
        className={style['order-details-selected-content-grid-layout']}
        column1Sections={column1Sections}
        column2Sections={column2Sections}
        column3Sections={column3Sections}
        fulfillmentPlannerSections={fulfillmentPlannerSections}
        primaryShipmentSections={primaryShipmentSections}
        rateCard={rateCard}
        secondaryShipmentSections={secondaryShipmentSections}
      />
    </div>
  );
};
